var USE_ONLY_PREFERRED_NAME = ['cs', 'ja', 'ko', 'pl', 'ro', 'tr', 'zh-cn', 'zh-tw'];
var WITH_PREFERRED_FIRST_LAST = ['de', 'fr-ca', 'fr', 'id', 'it', 'th'];
var WITH_PREFERRED_LAST_FIRST = ['hu'];
var WITHOUT_PREFERRED_LAST_FIRST = ['hu', 'ko'];
var WITHOUT_PREFERRED_COMBINE_LAST_FIRST = ['zh-cn', 'zh-tw'];
var SAN = 'さん';
var WITHOUT_PREFERRED_LAST_FIRST_WITH_SAN = ['ja'];
export var formatEmployeeName = function (formatters, _a) {
    var firstName = _a.firstName, lastName = _a.lastName, preferredName = _a.preferredName, fullName = _a.fullName;
    // backwards compatibility
    if (!firstName && !lastName && !preferredName) {
        return fullName;
    }
    var locale = formatters.preferences.locale;
    var lowerCaseLang = locale.toLowerCase();
    if (preferredName) {
        if (USE_ONLY_PREFERRED_NAME.includes(lowerCaseLang)) {
            return preferredName;
        }
        if (WITH_PREFERRED_FIRST_LAST.includes(lowerCaseLang)) {
            return "".concat(firstName, " ").concat(lastName);
        }
        if (WITH_PREFERRED_LAST_FIRST.includes(lowerCaseLang)) {
            return "".concat(lastName, " ").concat(firstName);
        }
        return "".concat(preferredName, " ").concat(lastName);
    }
    if (WITHOUT_PREFERRED_LAST_FIRST.includes(lowerCaseLang)) {
        return "".concat(lastName, " ").concat(firstName);
    }
    if (WITHOUT_PREFERRED_LAST_FIRST_WITH_SAN.includes(lowerCaseLang)) {
        return "".concat(lastName, " ").concat(firstName).concat(SAN);
    }
    if (WITHOUT_PREFERRED_COMBINE_LAST_FIRST.includes(lowerCaseLang)) {
        return "".concat(lastName).concat(firstName);
    }
    return "".concat(firstName, " ").concat(lastName);
};
